module.exports = __webpack_public_path__ + "img/fb.8eb956ce.svg";